import {Card, Grid} from "@varymadellc/my-weed-club-component-library";
import Page from "@/layout/Page";
import {useEffect, useState} from "react";
import {parseIcs} from "@/utils/parseIcs";
import {useAuth} from "@/providers/AuthProvider";
import {getGallery} from "@/services/getGalleryService";
import EventsPastPageMenu from "@/layout/nav/EventsPastPageMenu";
import {useSiteMessage} from "@/providers/SiteMessageProvider";
import {covertGalleryToList} from "@/components/getGalleryList";

export interface EventsPageProps {
    eventsIcs: string;
}

export default function EventsPage(props: EventsPageProps) {
    const {setMessage} = useSiteMessage();

    const {authToken} = useAuth();

    const {eventsIcs} = props;

    const [events, setEvents] = useState<Record<string, any>[]>([]);

    useEffect(() => {
        (async () => {
            try {
                if (!eventsIcs || !authToken) return;

                const parsedEvents = parseIcs(eventsIcs);

                if (!parsedEvents) return;

                const parsedEventsWithGalleries = await Promise.all(parsedEvents.map(async (event) => {
                    if (!event.galleryUuid) return null;

                    return {
                        ...event,
                        gallery: await getGallery(event.galleryUuid, authToken)
                    };
                }));

                setEvents(parsedEventsWithGalleries.filter(Boolean));
            } catch (error: any) {
                setMessage([error.message]);
            }
        })();
    }, [eventsIcs, authToken, setMessage]);


    function sortEvents(a: Record<string, any>, b: Record<string, any>) {
        const aDate = new Date(a?.dtstart || a?.dtstarttzid || a?.dtendext);

        const bDate = new Date(b?.dtstart || b?.dtstarttzid || b?.dtendext);

        return aDate.getTime() - bDate.getTime();
    }

    return (
        <Page title='Past Events'
              menu={<EventsPastPageMenu/>}>
            <Card>
                {
                    events?.length < 1 ? (
                        <div>Loading...</div>
                    ) : (
                        <Card>
                            {
                                events.sort(sortEvents).map((event, index) => {
                                    const startDate = new Date(event.dtstart || event.dtstarttzid || event.dtendext);

                                    if (!startDate) {
                                        return null;
                                    }

                                    const now = (new Date()).getTime();

                                    if (now < startDate.getTime()) return null;

                                    return (
                                        <div key={index}>
                                            <h2>{event.summary}</h2>
                                            <p>{event.description}</p>
                                            <p>{startDate.toLocaleString()}</p>
                                            <p>{event.end}</p>
                                            {event?.gallery &&
                                                <Grid perRow={9}>
                                                    {covertGalleryToList(event?.gallery, event?.gallery?.username, false)}
                                                </Grid>
                                            }
                                            <hr className="my-2 w-full border-primary"/>
                                        </div>
                                    );
                                }).filter(Boolean)
                            }
                            <p className="bg-black/50 text-white rounded text-xs p-1">This is a simplified version,
                                more features coming soon!</p>
                        </Card>
                    )
                }
            </Card>
        </Page>
    );
}

export async function getServerSideProps() {
    let data;

    try {
        const response = await fetch('https://calendar.google.com/calendar/ical/admin%40myweed.club/public/basic.ics');

        data = await response.text();

        return {
            props: {
                eventsIcs: data
            }
        }
    } catch (error: any) {
        console.error(error);

        return {
            props: {
                error: error.message
            }
        }
    }
}